import React from "react";
import { Icon } from "@iconify/react";

function MapIcon() {
  return (
    <div>
      <Icon
        icon="clarity:map-marker-line"
        color="#707070"
        width="60"
        height="59"
      />
    </div>
  );
}

export default MapIcon;
